import type { OktaAuth } from '@okta/okta-auth-js';

import type { User } from './types';

const getAccessToken = async (oktaAuth: OktaAuth): Promise<string> => {
  const { accessToken } = await oktaAuth.tokenManager.getTokens();

  return accessToken?.accessToken || '';
};

const getIdToken = async (oktaAuth: OktaAuth): Promise<string> => {
  const { idToken } = await oktaAuth.tokenManager.getTokens();

  return idToken?.idToken || '';
};

const getUser = async (oktaAuth: OktaAuth): Promise<User> => {
  const accessToken = await getAccessToken(oktaAuth);
  const { payload } = oktaAuth.token.decode(accessToken);
  const extendedPayload = payload as unknown as { sub?: string; lastname?: string; firstname?: string };

  return {
    email: extendedPayload.sub || '',
    family_name: extendedPayload.lastname || '',
    given_name: extendedPayload.firstname || '',
    name: `${extendedPayload.firstname || ''} ${extendedPayload.lastname || ''}`,
    preferred_username: extendedPayload.sub || ''
  };
};

export { getAccessToken, getIdToken, getUser };
